import React, { useState } from 'react';

import { Tooltip } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/tooltip.scss';

export type NcTooltipPropsT = {
  children: React.ReactNode;
  tooltipContent: string;
};

export const NcTooltip: React.FC<NcTooltipPropsT> = ({
  children,
  tooltipContent,
}) => {
  const [show, setShow] = useState(false);

  const handleTouchEnd = (event: React.TouchEvent<HTMLSpanElement>): void => {
    event.preventDefault();
    setShow((previouslyShown) => !previouslyShown);
  };

  return (
    <Tooltip
      onToggle={setShow}
      placement="bottom"
      rootClose
      show={show}
      tooltipClassName="nc-tooltip"
      tooltipContent={tooltipContent}
    >
      <span
        className="nc-tooltip-trigger"
        onTouchEnd={handleTouchEnd}
        role="button"
        tabIndex={0}
      >
        {children}
        <span className="visually-hidden">{tooltipContent}</span>
      </span>
    </Tooltip>
  );
};
